var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"uploadContent",on:{"click":_vm.uploadMethod}},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"alt":""}}):_c('i',{staticClass:"el-icon-plus"})]),_c('input',{ref:"upalod",staticClass:"file",attrs:{"id":"upload","type":"file","accept":"image/*"},on:{"change":_vm.handleSuccess}})])
}
var staticRenderFns = []

export { render, staticRenderFns }